module.exports = '1.1.4';



//////////////////
// WEBPACK FOOTER
// ./node_modules/sockjs-client/lib/version.js
// module id = ./node_modules/sockjs-client/lib/version.js
// module chunks = 0